import { ReactNode, useState } from 'react'
import clsx from 'clsx'
import Sidebar from './Sidebar'
import Footer from './Footer'
import MobileNav from './MobileNav'

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  return (
    <div className="min-h-screen app-shell">
      {/* Left Sidebar - Hidden on mobile */}
      <div className="hidden md:block">
        <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      </div>

      {/* Main Content Area */}
      <div
        className={clsx(
          'flex flex-col min-h-screen transition-all duration-300',
          'pb-16 md:pb-0', // Bottom padding for mobile nav
          isCollapsed ? 'md:ml-20' : 'md:ml-64' // Sidebar margin only on desktop
        )}
      >
        <main className="flex-1">
          {children}
        </main>
        <Footer />
      </div>

      {/* Mobile Bottom Navigation */}
      <MobileNav />
    </div>
  )
}

export default Layout
